const route = {
	name: 'restore-password',
	path: '/recuperar-contrasena',
	component: () => import('@/pages/page-restore-password'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/restore-password.js